import React, { useState, useContext } from 'react';
import CheckBoxInput from '../../../../../Components/CheckBoxInput';

import { ConfigContext } from '../../../../../Contexts/ConfigContext';
import PageHeading from '../../../../../Components/PageHeading';

//mui imports====
import useStyles from './styles';
import useCommonStyles from '../../../../../commonStyles';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import { Button, Grid, Paper } from '@mui/material';
//===============

const CustomStyleTagConfig = ({ keyData, featureDescription }) => {
	const { rawConfig, updateRawConfig } = useContext(ConfigContext); //rawConfig from ConfigContext
	const [innerHtml, setInnerHtml] = useState(
		rawConfig[keyData + '.customStyleTagConfig.customStyleTagInnerHtml']
	);

	const classes = useStyles();
	const commonStyleClasses = useCommonStyles();

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Custom Style Tag Config"
				headingPath={['Dashboard', 'Framerate', 'Format Data', 'Custom Style Tag']}
				description="This feature allows to inject custom css into page. Loads the custom css after player has completely loaded."
				showInfoButton={true}
				infoMessage={featureDescription}
			/>
			<Grid container spacing={2} className={commonStyleClasses.gridStyles}>
				<Grid
					item
					xs={12}
					style={{
						marginTop: '3rem',
						display: 'flex',
						alignItems: 'left'
					}}
				>
					<CheckBoxInput
						keyData={keyData + '.enabled'}
						label="enabled"
						disabled={false}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
						style={{ marginLeft: '2rem' }}
					/>
				</Grid>
				<Grid item xs={6} style={{ marginTop: '3rem' }}>
					<Typography className={commonStyleClasses.heading} fontWeight={400} variant="h4">
						Inner Html Current
					</Typography>
					<TextField
						id="outlined-multiline-static"
						multiline
						value={rawConfig[keyData + '.customStyleTagInnerHtml'] || ''}
						className={classes.innerHtmlTextField}
						maxRows={10}
						minRows={10}
						disabled={true}
					/>
				</Grid>
				<Grid item xs={6} style={{ marginTop: '3rem' }}>
					<Typography className={commonStyleClasses.heading} fontWeight={400} variant="h4">
						Inner Html Input
					</Typography>
					<TextField
						id="outlined-multiline-static"
						multiline
						onChange={(e) => {
							setInnerHtml(e.target.value);
						}}
						className={classes.innerHtmlTextField}
						maxRows={10}
						minRows={10}
					/>
				</Grid>
				<Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
					<Button
						variant="contained"
						onClick={() =>
							updateRawConfig((obj) => {
								return {
									...obj,
									[keyData + '.customStyleTagInnerHtml']: innerHtml
								};
							})
						}
					>
						Save Inner Html
					</Button>
				</Grid>
			</Grid>
		</Paper>
	);
};
export default CustomStyleTagConfig;
